module.exports = __webpack_public_path__ + "img/icon-32.159f9fca.svg";